// extracted by mini-css-extract-plugin
export default {"tooltip":"IT-z","arrow":"JT-z"};